import React, { useEffect } from "react";
import Layout from "./Layout";
import Footer from "./components/Footer";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { LoaderProvider, LoadingOverlay } from "stm-frontend-library";
import { useNavigate } from "react-router-dom";
import { initNavigationService } from "./utils/navigationService";

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    initNavigationService(navigate);
  }, [navigate]);

  return (
    <LoaderProvider>
      <LoadingOverlay />
      <ToastContainer />
      <Layout />
      <Footer />
    </LoaderProvider>
  );
};


export default App;